/* CP primero (Hogar Seguro MX): la clienta escribe su código postal y se llenan solos
   Estado, Municipio y CP en los selects originales de Releasit.
   No agrega campos a Releasit ni cambia su configuración: solo usa los selects que ya existen,
   con la cobertura que ya carga el tema (cod-coverage-v6.js + parche de Guadalupe).
   29-oct-2026 (formulario corto): cuando el CP se llena bien, los selects originales de
   Estado/Municipio/CP se PLIEGAN (siguen en el formulario y mandan su valor a Dropi, solo no se ven)
   con un enlace "Cambiar estado o municipio". Si falla el llenado, el CP cambia o falta un dato
   al enviar, vuelven a mostrarse. También se oculta la casilla de newsletter. */
(function () {
  if (!/^\/products\//.test(location.pathname)) return;

  var ID = 'hs-cp-primero';
  var NOTA_ID = 'hs-nota-pago-al-recibir';
  var ESTILO_ID = 'hs-cp-estilo';
  var ROJO = '#b3261e';
  var plegado = false;
  var setValor = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;

  function campo(n) { return document.querySelector('[name="' + n + '"]'); }

  function esperar(fn, ms) {
    return new Promise(function (ok) {
      var t0 = Date.now();
      (function vuelta() {
        var r = fn();
        if (r || Date.now() - t0 > (ms || 2500)) return ok(r);
        setTimeout(vuelta, 60);
      })();
    });
  }

  // Releasit es React: el valor se asigna con el setter nativo y luego se avisa con "change".
  function elegir(sel, valor) {
    setValor.call(sel, valor);
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function tieneOpcion(n, valor) {
    var el = campo(n);
    if (!el || el.tagName !== 'SELECT') return null;
    for (var i = 0; i < el.options.length; i++) if (el.options[i].value === valor) return el;
    return null;
  }

  // Se busca al momento, para respetar lo que el parche de Guadalupe ya quitó.
  function buscar(cp) {
    var d = window._CUSTOM_COD_FORM_PROVINCES && window._CUSTOM_COD_FORM_PROVINCES.data;
    var r = [];
    if (!d) return r;
    for (var e in d) for (var m in d[e]) if (d[e][m] && d[e][m][cp]) r.push({ estado: e, municipio: m });
    return r;
  }

  // --- Plegado de los selects originales (no se borran: siguen mandando el dato) ---
  function asegurarEstilo() {
    if (document.getElementById(ESTILO_ID)) return;
    var st = document.createElement('style');
    st.id = ESTILO_ID;
    st.textContent = '[data-hs-plegado="1"]{display:none!important}';
    document.head.appendChild(st);
  }

  function bloquesDireccion() {
    return ['province_country_field', 'city', 'zip_code']
      .map(campo).filter(Boolean).map(contenedor);
  }

  function completos() {
    var p = campo('province_country_field'), c = campo('city'), z = campo('zip_code');
    return !!(p && p.value && c && c.value && z && z.value);
  }

  function aplicarPlegado() {
    asegurarEstilo();
    bloquesDireccion().forEach(function (b) {
      if (plegado) b.setAttribute('data-hs-plegado', '1');
      else b.removeAttribute('data-hs-plegado');
    });
    var l = document.getElementById('hs-cp-cambiar');
    if (l) l.style.display = plegado ? 'inline-block' : 'none';
  }

  function plegar(si) {
    plegado = !!si;
    aplicarPlegado();
  }

  async function llenar(op, cp, caja) {
    plegar(false);
    mensaje(caja, 'Llenando tu estado y municipio…', '');
    var prov = campo('province_country_field');
    if (!prov) return;
    elegir(prov, op.estado);
    var ciudad = await esperar(function () { return tieneOpcion('city', op.municipio); });
    if (!ciudad) return mensaje(caja, 'No pudimos llenarlo solo. Elige tu estado y municipio abajo.', ROJO);
    elegir(ciudad, op.municipio);
    var zip = await esperar(function () { return tieneOpcion('zip_code', cp); });
    if (!zip) return mensaje(caja, 'Elige tu código postal abajo.', ROJO);
    elegir(zip, cp);
    mensaje(caja, '✓ ' + titulo(op.municipio) + ', ' + titulo(op.estado), '#1b6e3a');
    // Solo se pliega si de verdad quedaron los tres datos.
    await esperar(completos, 1500);
    plegar(completos());
  }

  function titulo(s) {
    return s.toLowerCase().replace(/\S+/g, function (p, i) {
      return i > 0 && /^(de|del|la|las|los|y)$/.test(p) ? p : p.charAt(0).toUpperCase() + p.slice(1);
    });
  }

  function mensaje(caja, texto, color) {
    var m = caja.querySelector('.hs-cp-msg');
    m.textContent = texto;
    m.style.color = color || 'inherit';
    m.style.display = texto ? 'block' : 'none';
  }

  function resaltarAviso(si) {
    var a = document.getElementById('hs-aviso-wa-municipio');
    if (!a) return;
    a.style.background = si ? '#fff4d6' : '';
    a.style.padding = si ? '8px 10px' : '';
    a.style.borderRadius = si ? '8px' : '';
    a.style.opacity = si ? '1' : '';
  }

  // Si los selects traen otra dirección (por un CP anterior), se limpian para no mandar datos ajenos.
  function limpiarSiNoCoincide(cp) {
    var prov = campo('province_country_field');
    var zip = campo('zip_code');
    if (prov && prov.value && (!zip || zip.value !== cp)) elegir(prov, '');
  }

  function alEscribir(input, caja) {
    var cp = input.value.replace(/\D/g, '').slice(0, 5);
    if (input.value !== cp) input.value = cp;
    var lista = caja.querySelector('.hs-cp-opciones');
    lista.innerHTML = '';
    resaltarAviso(false);
    plegar(false);
    if (cp.length < 5) return mensaje(caja, '', '');
    var ops = buscar(cp);
    if (ops.length !== 1) limpiarSiNoCoincide(cp);
    if (!ops.length) {
      mensaje(caja, 'En tu código postal la paquetería no cobra al recibir. Escríbenos por WhatsApp (aquí abajo) y te lo enviamos con pago en efectivo en OXXO.', ROJO);
      caja.querySelector('.hs-cp-msg').style.background = '#fdecea';
      resaltarAviso(true);
      return;
    }
    caja.querySelector('.hs-cp-msg').style.background = '';
    if (ops.length === 1) return llenar(ops[0], cp, caja);
    mensaje(caja, 'Ese código postal es de varios municipios. Elige el tuyo:', '');
    ops.forEach(function (op) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = titulo(op.municipio) + ', ' + titulo(op.estado);
      b.style.cssText = 'display:block;width:100%;margin:6px 0 0;padding:12px;font:inherit;font-size:16px;text-align:left;border:1px solid #c9c9c9;border-radius:10px;background:#fff;color:inherit;cursor:pointer;';
      b.addEventListener('click', function () { lista.innerHTML = ''; llenar(op, cp, caja); });
      lista.appendChild(b);
    });
  }

  function crearCaja() {
    var caja = document.createElement('div');
    caja.id = ID;
    caja.style.cssText = 'grid-column:1/-1;margin:4px 0 14px;';
    caja.innerHTML =
      '<label for="hs-cp-input" style="display:block;font:inherit;font-weight:600;margin-bottom:6px;">Código postal</label>' +
      '<input id="hs-cp-input" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="5" autocomplete="postal-code" placeholder="Ej. 66477" ' +
      'style="width:100%;box-sizing:border-box;font:inherit;font-size:22px;letter-spacing:3px;padding:14px 16px;border:2px solid #0e5540;border-radius:10px;background:#fff;color:inherit;">' +
      '<p style="margin:6px 2px 0;font:inherit;font-size:14px;opacity:.8;">Escribe tu código postal y llenamos tu estado y municipio</p>' +
      '<p class="hs-cp-msg" style="display:none;margin:8px 0 0;padding:8px 10px;border-radius:8px;font:inherit;font-size:14px;"></p>' +
      '<a href="#" id="hs-cp-cambiar" style="display:none;margin:6px 2px 0;font:inherit;font-size:14px;text-decoration:underline;color:inherit;">Cambiar estado o municipio</a>' +
      '<div class="hs-cp-opciones"></div>';
    var input = caja.querySelector('input');
    input.addEventListener('input', function () { alEscribir(input, caja); });
    // Enter no debe enviar el formulario.
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    caja.querySelector('#hs-cp-cambiar').addEventListener('click', function (e) { e.preventDefault(); plegar(false); });
    return caja;
  }

  function contenedor(el) {
    var c = el.parentElement;
    while (c && c.parentElement && c.parentElement.querySelectorAll('[name]').length <= 1) c = c.parentElement;
    return c || el;
  }

  function colocar() {
    var prov = campo('province_country_field');
    if (!prov) return;
    var form = prov.closest('form') || document;
    if (!form.querySelector('#' + ID)) contenedor(prov).insertAdjacentElement('beforebegin', crearCaja());

    var tel = campo('phone');
    if (tel && tel.getAttribute('inputmode') !== 'numeric') tel.setAttribute('inputmode', 'numeric');

    // Casilla de newsletter: se oculta (no aporta y alarga el formulario).
    var nl = campo('newsletter_subscribe_checkbox');
    if (nl) { asegurarEstilo(); contenedor(nl).setAttribute('data-hs-plegado', '1'); }

    var boton = form.querySelector('button[type="submit"]');
    if (boton && !form.querySelector('#' + NOTA_ID)) {
      var n = document.createElement('p');
      n.id = NOTA_ID;
      n.textContent = 'No pagas nada ahora · Pagas al recibir';
      n.style.cssText = 'grid-column:1/-1;margin:4px 0 8px;text-align:center;font:inherit;font-size:15px;font-weight:700;';
      // Va arriba de la fila del botón (si se pone junto al botón, la fila es horizontal y lo aplasta).
      (boton.closest('.rsi-custom-button-row') || boton).insertAdjacentElement('beforebegin', n);
    }
    // Seguridad: si al enviar falta estado, municipio o CP, se vuelven a mostrar para que lo vea.
    if (boton && !boton.getAttribute('data-hs-guardia')) {
      boton.setAttribute('data-hs-guardia', '1');
      boton.addEventListener('click', function () { if (!completos()) plegar(false); }, true);
    }
    // Releasit puede volver a pintar los campos: se reaplica el plegado vigente.
    if (plegado && !completos()) plegado = false;
    aplicarPlegado();
  }

  new MutationObserver(colocar).observe(document.documentElement, { childList: true, subtree: true });
  colocar();
})();
